'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.FileInputButtonWithHook = void 0;

var _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _index = require('./index'),
    _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var onClick = function onClick(a) {
  var b = a.fileInputRef;
  b.current.click();
},
    FileInputButtonWithHook = exports.FileInputButtonWithHook = function (a) {
  var b = a.onChange,
      c = a.showSpinner,
      d = a.disabled,
      e = a.text,
      f = a.accept,
      g = a.multiple,
      h = a.iconName,
      i = _react2.default.useRef({});

  return _react2.default.createElement(_index2.default, {
    text: e,
    multiple: g,
    disabled: d,
    accept: f,
    fileInputRef: i,
    onChange: b,
    showSpinner: c,
    onClick: _react2.default.useCallback(function () {
      return onClick({
        fileInputRef: i
      });
    }, []),
    iconName: h
  });
};

FileInputButtonWithHook.propTypes = {
  onChange: _propTypes2.default.func,
  showSpinner: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  text: _propTypes2.default.string,
  accept: _propTypes2.default.string,
  multiple: _propTypes2.default.bool,
  iconName: _propTypes2.default.string
}, FileInputButtonWithHook.defaultProps = {
  onChange: function a() {},
  showSpinner: !1,
  disabled: !1,
  text: 'Upload Files',
  accept: 'image/*',
  multiple: !1,
  iconName: 'Upload'
}, exports.default = _react2.default.memo(FileInputButtonWithHook);